module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal .collapse.show",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "fraudModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "delete-body"
  }, [_c('div', {
    staticClass: "body-title"
  }, [_vm._v("\n          Para marcar esta biometria como suspeita de fraude, preencha o motivo abaixo e clique em enviar.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fraud-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "fraud-label"
  }, [_vm._v("Código SAF")]), _vm._v(" "), _c('input', {
    staticClass: "fraud-field",
    attrs: {
      "type": "text",
      "placeholder": _vm.safCode,
      "readonly": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fraud-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "fraud-label"
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "fraud-field",
    attrs: {
      "rows": "6",
      "cols": "85",
      "id": "motivodesc",
      "required": ""
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.sendToFraud
    }
  }, [_vm._v("\n          Salvar\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete-modal-header"
  }, [_c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Suspeita de Fraude")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43772e05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/FraudModal.vue
// module id = 254
// module chunks = 0